<div class="container">
    <div class="row no-gutters">
        <div class="col-12" *ngIf="editAppointmentService.appointmentDetails" >

            <div class="popup-head d-flex flex-column w-100">
                <div class="d-flex align-items-center w-100 min-h55">
                    <div class="d-flex align-items-center no-gutters mr-auto">

                        <div class="pll10 d-flex align-items-center  pr-4 border-right" tabindex="1"
                            *ngIf="appointmentDetails">
                            <div class="flmid">
                                <div class="licplate LPNo d-flex scale">
                                    <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                                    {{appointmentDetails.licensePlate}}
                                </div>
                                <button class="btn btn-link ml-40" (click)="copyLicencePlateNo()" placement="bottom"
                                    ngbTooltip="Copy No." aria-label="Center Align">
                                    <em class="fas fa-copy fa-lg text-white"></em>
                                </button>
                            </div>
                        </div>

                        <div class="ml-4 font20 pr-4 border-right">#{{appointmentDetails.workOrderNo}}
                            <button class="btn btn-link ml-2" (click)="copyTextWoNumber()" placement="bottom"
                                ngbTooltip="Copy WO No." aria-label="Center Align">
                                <em class="fas fa-copy fa-lg text-white"></em>
                            </button>
                        </div>

                        <div class="ml-4 font20 pr-4 border-right">
                            <div class="color-box shd"
                                [style.background-color]="editAppointmentService.appointmentDetails.workorderStatusColor">
                            </div>
                            {{editAppointmentService.appointmentDetails.workorderStatus}} 
                            <span *ngIf="commonService.IsonHoldStatus">
                                - ({{editAppointmentService.appointmentDetails.onHoldReason}})
                                <span *ngIf="commonService?.appointmentDetails?.onHoldReasonDescription">
                                    <em class="fas fa-info-circle fa-lg" placement="bottom"
                                        [ngbTooltip]="commonService.appointmentDetails.onHoldReasonDescription"></em>
                                </span>
                            </span>
                        </div>
                        <div class="ml-4 font20" *ngIf="appointmentDetails.appointmentType" translate>lblType: <span class=""
                                translate>lbl{{appointmentDetails.appointmentType}}</span>
                        </div>
                        <div class="ml-4 font20" *ngIf="!appointmentDetails.appointmentType" translate>lblType: <span
                                class="">{{appointmentDetails.appointmentType}}</span>
                        </div>
                        <div class="ml-4 font20 pl-4 border-left" *ngIf="appointmentDetails.isCustomerWaiting">
                            <img src="./../../../assets/images/customerwaiting.png" height="30" width="30" alt=""
                                ngbTooltip="{{'lblCustomerWaiting'  | translate }}" />
                        </div>
                        <div class="ml-4 font20 pl-4 border-left" *ngIf="editAppointmentService.appointmentDetails.mpoOfferNo > 0"><span
                            class="" translate="">lblOfferNo</span><span> - {{appointmentDetails.mpoOfferNo}}</span>
                            <a [href]="appointmentDetails.mpoUrl" target="_blank">
                                <img class="mpoLink" src="./../../../assets/images/Link.png" width="20" alt="" ngbTooltip="Go for MPO offer"
                                placement="left" />
                            </a>
                        </div>

                    </div>

                    <div class="mr-2 edit-iconlist">
                        <ul class="list-inline d-flex">
                            <li *ngIf="isMg">
                                <a class="btn btn-ico mx-2" placement="left" tooltipClass="custom-revert" (click)="customerComments?.length > 0 ? ViewComment(viewComment) : void()" ngbTooltip="{{'lblCustomerCommets' | translate}}">
                                    <em class="font30 text-white fas fa-eye fa-lg" [ngClass]="{'text-muted' : !customerComments || customerComments.length === 0}"></em>
                                    <span class="position-absolute translate-middle badge rounded-pill count" *ngIf="customerComments?.length > 0"
                                        style="margin-top: 9px !important; margin-left: -5px !important; background-color: #ED5153; color: #ffff;">
                                        {{customerComments?.length}}</span>
                                </a>
                            </li>
                            <li *ngIf="workorderService.isAnyWarrantyDemandExists">
                                <a class="btn btn-ico mx-2" placement="left" tooltipClass="custom-revert"
                                    [ngbTooltip]="(workorderService.isWarrantyDocumentSigned ? 'lblWarrantyDocumentSigned' : (workorderService.isWarrantyDocumentGenerated ? 'lblWarrantyDocumentGenerated' : 'lblWarrantyDemandExists')) | translate">
                                    <em class="fas fa-award mr-2 font40" [ngClass]="workorderService.isWarrantyDocumentSigned ? 'text-success' : (workorderService.isWarrantyDocumentGenerated ? 'text-yellow' : 'text-white')"></em>
                                </a>
                            </li>
                            <li *ngIf="editAppointmentService.appointmentDetails.brandName.toLowerCase() === 'nissan'
                            && editAppointmentService.appointmentDetails.appointmentType !== 'Quote'">
                                <a class="btn btn-ico mx-2" placement="left" tooltipClass="custom-revert"
                                    ngbTooltip="{{'lblSyncDemandToSST' | translate}}" (click)="syncDemandToSST()">
                                    <em class="font30 text-white fas fa-file-export"></em>
                                </a>
                            </li>
                            <li>
                                <a class="btn btn-ico mx-2" placement="left" tooltipClass="custom-revert"
                                    ngbTooltip="{{'lblAppointmentConfirmation' | translate}}" (click)="onAppointmentCofirmation(viewPreView)">
                                    <em class="font30 text-white fas fa-envelope fa-lg"></em>
                                </a>
                            </li>
                            <li>
                                <a class="btn btn-ico mx-2" placement="left" tooltipClass="custom-revert"
                                    *ngIf="userRoleRightsDetails.canDelete && editAppointmentService.isDelete && !this.editAppointmentService.appointmentDetails.isFromArchive; else disabledDelete"
                                    (click)="onDelete()" ngbTooltip="{{'lblDelete' | translate}}">
                                    <em class="font30 text-white fas fa-trash fa-lg"></em>
                                </a>
                                <ng-template #disabledDelete>
                                    <a class="btn btn-ico disabled" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert">
                                        <em class="far fa-trash-alt fa-lg text-muted"></em>
                                    </a>
                                </ng-template>
                                </li>
                                <li>
                                <a class="btn btn-ico mx-2" ngbTooltip="Refresh" placement="left"
                                    tooltipClass="custom-revert" (click)="onRefresh()">
                                    <em class="font30 text-white fas fa-sync fa-lg"></em>
                                </a>
                            </li>
                           
                            <!-- TecRmi -->
                            <li class="no-arrow" ngbDropdown placement="bottom-end"
                                *ngIf="editAppointmentService.isTecRMIEnabled && !editAppointmentService.appointmentDetails.isFromArchive">
                                <button class="text-white btn-ico mx-2" tabindex="0" ngbDropdownToggle
                                    id="navbarDropdownTecRMI" role="button" ngbTooltip="TecRMI" placement="left"
                                    tooltipClass="custom-revert">
                                    <em class="font28 text-white fas fa-tools fa-lg"></em>
                                </button>
                                <div ngbDropdownMenu aria-labelledby="navbarDropdownTecRMI"
                                    class="dropdown-menu-right drop-menu p-0">
                                    <a ngbDropdownItem class="font-15" (click)="onTechRmiMaintenance()"
                                        [disabled]="!editAppointmentService.isEdit">
                                        <span translate>lblTecRmiMaintenance</span></a>
                                    <a ngbDropdownItem class="font-15" (click)="onTechRmiLabour()"
                                        [disabled]="!editAppointmentService.isEdit">
                                        <span translate>lblTecRmiLabour</span></a>
                                    <a ngbDropdownItem class="font-15" href="{{ tecRmiLoginUrl }}" target="_blank"
                                        rel="noopener" [disabled]="!editAppointmentService.isEdit"><span
                                            translate>TecRMI Login</span></a>
                                </div>
                            </li>

                            <li
                                *ngIf="isDsoActive && editAppointmentService.appointmentDetails.appointmentType !== 'Quote' ">
                                <a class="btn btn-ico mx-2" ngbTooltip="Parking" placement="left"
                                    tooltipClass="custom-revert" (click)="openParking()">
                                    <em class="font32 text-white icon-parking"></em>
                                </a>
                            </li>
                            <li class="no-arrow" ngbDropdown placement="bottom-end"
                                *ngIf="editAppointmentService.isSSMEnabled && !editAppointmentService.appointmentDetails.isFromArchive">
                                <button class="text-white" tabindex="0" ngbDropdownToggle id="navbarDropdownSSm"
                                    role="button">

                                    <img src="./../../../assets/images/ssm.svg" width="30" alt="" ngbTooltip="SSM"
                                        placement="left" />


                                </button>

                                <div ngbDropdownMenu aria-labelledby="navbarDropdownSSm"
                                    class="dropdown-menu-right drop-menu p-0">

                                    <a ngbDropdownItem class="font-15" (click)="exportSSM()"
                                        [disabled]="!editAppointmentService.isEdit">
                                        <span translate>lblSSMImportOrder</span></a>

                                    <a ngbDropdownItem class="font-15" (click)="importSSM()"
                                        [disabled]="!editAppointmentService.isEdit">

                                        <span translate>lblSSMSendVIN</span></a>
                                    <a ngbDropdownItem class="font-15" href="https://login.superservice.com/login/no-ny"
                                        target="_blank" rel="noopener" [disabled]="!editAppointmentService.isEdit"><span
                                            translate>lblSSMLogin</span></a>

                                </div>
                            </li>

                            <!-- MPO -->

                            <li class="no-arrow" ngbDropdown placement="bottom-end"
                            *ngIf="editAppointmentService.isMPOEnabled && !editAppointmentService.appointmentDetails.isFromArchive">
                            <button class="text-white" tabindex="0" ngbDropdownToggle id="navbarDropdownMpo"
                                role="button">

                                <img src="./../../../assets/images/ssm.svg" width="30" height="27" alt="" ngbTooltip="MPO"
                                    placement="left" />


                            </button>

                            <div ngbDropdownMenu aria-labelledby="navbarDropdownMpo"
                                class="dropdown-menu-right drop-menu p-0">

                                <a ngbDropdownItem class="font-15" (click)="GetMpoOffer()"
                                    [disabled]="!editAppointmentService.isEdit">
                                    <span translate>lblGetOffer</span></a>

                                <a ngbDropdownItem class="font-15" (click)="CreateOfferInMpo()"
                                    [disabled]="!editAppointmentService.isEdit">

                                    <span translate>lblCreateOffer</span></a>
                                <a ngbDropdownItem class="font-15" href="https://mpo-15133.preview.mpo-cpl.com/"
                                    target="_blank" rel="noopener" [disabled]="!editAppointmentService.isEdit"><span
                                        translate>lblMPOLogin</span></a>

                            </div>
                        </li>

                            <!-- Romnas -->
                            <li class="no-arrow" ngbDropdown placement="bottom-end"
                                *ngIf="editAppointmentService.isRomnasEnabled && !editAppointmentService.appointmentDetails.isFromArchive">
                                <button class="text-white" tabindex="0" ngbDropdownToggle id="navbarDropdownSSm"
                                    role="button">
                                    <img src="./../../../assets/images/ssm.svg" width="30" alt="" ngbTooltip="Romnes"
                                        placement="left" />
                                </button>

                                <div ngbDropdownMenu aria-labelledby="navbarDropdownSSm"
                                    class="dropdown-menu-right drop-menu p-0">
                                    <a ngbDropdownItem class="font-15" (click)="getRomnasAutoLoginUrl()"
                                        [disabled]="!editAppointmentService.isEdit">
                                        <span translate>lblRomnasLogin</span></a>
                                    <a ngbDropdownItem class="font-15" (click)="importRomnasBasket()"
                                        [disabled]="!editAppointmentService.isEdit">
                                        <span translate>lblRomnasImportBasket</span></a>
                                </div>
                            </li>

                            <li ngbDropdown display="dynamic" placement="bottom-end" class="no-arrow"
                                *ngIf="!editAppointmentService.appointmentDetails.isFromArchive && editAppointmentService.appointmentDetails.licensePlate && editAppointmentService.appointmentDetails.appointmentType !== 'Quote'">

                                <button class="text-white" id="dropdownBasic2" ngbDropdownToggle><i
                                        class="fa fa-globe fa-2x" aria-hidden="true" (click)="isCheckin()"></i></button>
                                <div *ngIf="(editAppointmentService.checkInURL || editAppointmentService.trackerURL) && isDisplayCheckInTrackerUrl"
                                    ngbDropdownMenu aria-labelledby="dropdownBasic2" class="dropdown-menu-right">
                                    <div class="d-flex" *ngIf="editAppointmentService.checkInURL">
                                        <a class="font-15 mr-auto" (click)="openCheckIn()" ngbDropdownItem rel="noopener noreferrer"
                                            translate>lblCheckInUrl</a>
                                        <button class="btn btn-link ml-auto" (click)="copyCheckInLink()" placement="top"
                                            ngbTooltip="Copy CheckInURL" aria-label="Center Align">
                                            <em class="fas fa-copy fa-lg"></em>
                                        </button>
                                    </div>

                                    <div *ngIf="editAppointmentService.trackerURL" class="drop-menu d-flex">

                                        <a class="font-15 mr-auto" [href]="editAppointmentService.trackerURL"
                                            target="_blank" ngbDropdownItem rel="noopener noreferrer"
                                            translate>lblStatusTrackerUrl</a>

                                        <button class="btn btn-link ml-auto" (click)="copyTrackerLink()" placement="top"
                                            ngbTooltip="Copy TrackerURL" aria-label="Center Align">

                                            <em class="fas fa-copy fa-lg"></em>
                                        </button>
                                    </div>

                                </div>

                            </li>

                            <li>
                                <a (click)="OpenSendNotificationModel()" class="btn btn-ico mx-2"
                                    ngbTooltip="{{'lblSendNotification' | translate}}" placement="left"
                                    tooltipClass="custom-revert">
                                    <img src="./../../../assets/images/bell-regular-wh.svg" width="30" alt="" />
                                </a>
                            </li>
                            <li *ngIf="!editAppointmentService.appointmentDetails.isFromArchive && shareBox">
                                <a (click)="SendSharBoxInformation()" class="btn btn-ico mx-2"
                                    ngbTooltip="{{'lblSendSharBoxInformation' | translate}}" placement="left"
                                    tooltipClass="custom-revert">
                                    <img src="./../../../assets/images/sharebox.png" width="30" alt="" />
                                </a>
                            </li>
                            <li *ngIf="editAppointmentService.isDownloadOffer">
                                <a (click)="OpenPdfModel(false)" class="btn btn-ico" [ngbTooltip]="pdfToolTip"
                                    placement="left" tooltipClass="custom-revert">
                                    <img src="./../../../assets/images/pdf-wh.svg" height="30" width="30" alt="" />
                                </a>
                            </li>
                             <!-- Invoice -->
                             <li *ngIf="isGenerateInvocie">
                                <a class="btn btn-ico mx-2" ngbTooltip="Invoice" placement="left"
                                    tooltipClass="custom-revert" (click)="onInvoice()">
                                    <em class="font30 text-white fas fa-file-invoice-dollar fa-lg"></em>
                                </a>
                            </li>
                            <li *ngIf="isDisplyDownloadOrderButton">
                                <a class="btn btn-ico mx-2" ngbTooltip="Print" placement="left"
                                    tooltipClass="custom-revert" (click)="OpenPdfModel(true)">
                                    <em class="font30 text-white fas fa-print fa-lg"></em>
                                </a>
                            </li>

                            <li>
                                <a class="close" (click)="CheckDataSynced('close')" translate>
                                    <span class="" aria-hidden="true">&times;</span>
                                </a>
                            </li>
                        </ul>

                    </div>
                </div>
                <ul ngbNav #nav="ngbNav" class="nav-tabs bg-grey">
                    <li *ngFor="let tab of this.editAppointmentService.AppointmentGenericTabs" class="nav-item">
                        <ng-container *ngIf="tab">
                            <a translate class="nav-link" (click)="CheckDataSynced(tab)"
                                [ngClass]="{'active': selectedtab===tab.id}">{{tab.label}}</a>
                        </ng-container>
                    </li>
                </ul>
            </div>
            <ng-cotainer *ngIf="editAppointmentService.isOpenByOtherUser">
                <div class="col-12">
                    <div class="alert alert-warning font18 text-center p-2 m-0">{{isOpenByOtherUserMsg}}</div>
                </div>
            </ng-cotainer>
            <ng-container
                *ngIf="message">
                <div class="col-12">
                    <div class="alert alert-warning alert-dmssync font18 text-center p-2 m-0">
                        {{message}}
                            <button type="button" class="btn btn-secondary btn-md" (click)="openExpiredQuote()" *ngIf="editAppointmentService.appointmentDetails.isQuoteExipred && !this.editAppointmentService.appointmentDetails.isFromArchive"
                                translate>lblReOpenQuote</button>
                    </div>
                </div>
            </ng-container>
            <ng-cotainer *ngIf="selectedtab===1"
                [ngClass]="{ 'mvh-200' : (editAppointmentService.isLockFeatureEnabled && editAppointmentService.isOpenByOtherUser) || this.message }">
                <app-appointment-work-order (onGetContactDetails)="onGetContactDetail($event)"
                    (showPdf)="showPdfIcon($event)" (isRefreshTab)="refreshTab($event)" (closeFromAppiontmentWO)="CheckDataSynced('close')"
                    (onShiftAppointment)="onRefresh()" [isOpenFromPlanning]="isOpenFromPlanning" [isViewAppointmentFromWAR]="isViewAppointmentFromWAR">
                </app-appointment-work-order>
            </ng-cotainer>
            <ng-cotainer *ngIf="selectedtab===2"
                [ngClass]="{ 'mvh-200' : (editAppointmentService.isLockFeatureEnabled && editAppointmentService.isOpenByOtherUser) || this.message }">
                <app-appointment-additional-work></app-appointment-additional-work>
            </ng-cotainer>
            <ng-cotainer *ngIf="selectedtab===3"
                [ngClass]="{ 'mvh-200' : (editAppointmentService.isLockFeatureEnabled && editAppointmentService.isOpenByOtherUser) || this.message }">
                <app-appointment-planning (loadErrorMessage)="loadErrorMessage($event)"></app-appointment-planning>
            </ng-cotainer>
            <ng-cotainer *ngIf="selectedtab===4"
                [ngClass]="{ 'mvh-200' : (editAppointmentService.isLockFeatureEnabled && editAppointmentService.isOpenByOtherUser) || this.message }">
                <app-appointment-dwo [isFromArchive]="editAppointmentService.appointmentDetails.isFromArchive"></app-appointment-dwo>
            </ng-cotainer>
            <ng-cotainer *ngIf="selectedtab===5"
                [ngClass]="{ 'mvh-200' : (editAppointmentService.isLockFeatureEnabled && editAppointmentService.isOpenByOtherUser) || this.message }">
                <app-appointment-communication></app-appointment-communication>
            </ng-cotainer>
            <ng-cotainer *ngIf="selectedtab===6"
                [ngClass]="{ 'mvh-200' : (editAppointmentService.isLockFeatureEnabled && editAppointmentService.isOpenByOtherUser) || this.message }">
                <app-appointment-parking></app-appointment-parking>
            </ng-cotainer>
            <ng-cotainer *ngIf="selectedtab===7"
                [ngClass]="{ 'mvh-200' : (editAppointmentService.isLockFeatureEnabled && editAppointmentService.isOpenByOtherUser) || this.message}">
                <app-appointment-work-order-history></app-appointment-work-order-history>
            </ng-cotainer>
            <ng-cotainer *ngIf="selectedtab===8"
                [ngClass]="{ 'mvh-200' : (editAppointmentService.isLockFeatureEnabled && editAppointmentService.isOpenByOtherUser) || this.message}">
                <app-appointment-document></app-appointment-document>
            </ng-cotainer>
            <ng-cotainer *ngIf="selectedtab===9"
                [ngClass]="{ 'mvh-200' : (editAppointmentService.isLockFeatureEnabled && editAppointmentService.isOpenByOtherUser) || this.message }">
                <app-appointment-invoice></app-appointment-invoice>
            </ng-cotainer>
            <ng-cotainer *ngIf="selectedtab===10"
                [ngClass]="{ 'mvh-200' : (editAppointmentService.isLockFeatureEnabled && editAppointmentService.isOpenByOtherUser) || this.message }">
                <app-appointment-update></app-appointment-update>
            </ng-cotainer>
            <ng-cotainer *ngIf="selectedtab===11"
                [ngClass]="{ 'mvh-200' : (editAppointmentService.isLockFeatureEnabled && editAppointmentService.isOpenByOtherUser) || this.message}">
                <app-whatsapp-messages [appointmentId]="appointmentId" [customerName]="customerName"
                    [customerContactNo]="customerContactNo"></app-whatsapp-messages>
            </ng-cotainer>
            <ng-cotainer *ngIf="selectedtab===12"
                [ngClass]="{ 'mvh-200' : (editAppointmentService.isLockFeatureEnabled && editAppointmentService.isOpenByOtherUser) || this.message}">
                <app-sharebox-log></app-sharebox-log>
            </ng-cotainer> 
        </div>
    </div>
</div>

<ng-template #viewComment let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblCustomerCommets
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"><span
                aria-hidden="true">×</span></button>
    </div>
    <div class="modal-body table-responsive">
        <table class="tablest1">
            <thead>
                <tr>
                    <th translate>lblComment</th>
                    <th translate>lblCreatedDate</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="customerComments?.length > 0; else load_else_comments">
                    <tr *ngFor="let data of customerComments">
                        <td>
                            {{data.comment ? data.comment : ''}}
                        </td>
                        <td>
                            {{data.updatedDate | date : 'short'}}
                        </td>
                    </tr>
                </ng-container>
                <ng-template #load_else_comments>
                    <tr>
                        <td colspan="4" class="no-record" translate>lblNoRecordsFound</td>
                    </tr>
                </ng-template>
            </tbody>
        </table>
    </div>
</ng-template>

<ng-template #viewComment let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblCustomerCommets
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"><span
                aria-hidden="true">×</span></button>
    </div>
    <div class="modal-body table-responsive">
        <table class="tablest1">
            <thead>
                <tr>
                    <th translate>lblComment</th>
                    <th translate>lblCreatedDate</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="customerComments?.length > 0; else load_else_comments">
                    <tr *ngFor="let data of customerComments">
                        <td>
                            {{data.comment ? data.comment : ''}}
                        </td>
                        <td>
                            {{data.updatedDate | date : 'short'}}
                        </td>
                    </tr>
                </ng-container>
                <ng-template #load_else_comments>
                    <tr>
                        <td colspan="4" class="no-record" translate>lblNoRecordsFound</td>
                    </tr>
                </ng-template>
            </tbody>
        </table>
    </div>
</ng-template>
<ng-template #viewPreView let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblPreview
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.close('Cross click')"><span
                aria-hidden="true">×</span></button>
    </div>
    <div class="modal-body table-responsive remark">
        <div class="row">
            <div class="col col-12">
                <div class="form-group">
                    <label for="Channel2" translate>lblEmail</label>
                    <strong _ngcontent-gcu-c285="" class="mlt6 required"> * </strong>
                    <input type="text" [(ngModel)]="confirmAppointmentEmail" class="form-control"/>
                </div>
            </div>
            <div class="col col-12">
                <div class="form-group">
                    <label for="Channel2" translate>lblSubject</label>
                    <strong _ngcontent-gcu-c285="" class="mlt6 required"> * </strong>
                    <input type="text" [(ngModel)]="templateLegendResponseModel.item1" class="form-control"/>
                </div>
            </div>
             <div class="col col-12">
                <quill-editor format= "html" [(ngModel)]="templateLegendResponseModel.item2" [modules]="options"
                              [preserveHtml]="templateLegendResponseModel.item2"
                              #emailQuillEditor="quillPreserveHtml" (onEditorCreated)="onEditorCreated($event)"
                              ></quill-editor>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary mr-sm-2" translate
            (click)="SendNotification(); modal.close('Cancel click')" [disabled]="!confirmAppointmentEmail || !templateLegendResponseModel.item1">
            <em class="fas fa-paper-plane"></em> lblSendNotification
        </button>
        <button type="button" class="btn btn-secondary btn-md" (click)="modal.close('Cancel click')"
            translate>lblCancel</button>
    </div>
</ng-template>

<ng-template #viewComment let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblCustomerCommets
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"><span
                aria-hidden="true">×</span></button>
    </div>
    <div class="modal-body table-responsive">
        <table class="tablest1">
            <thead>
                <tr>
                    <th translate>lblComment</th>
                    <th translate>lblCreatedDate</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="customerComments?.length > 0; else load_else_comments">
                    <tr *ngFor="let data of customerComments">
                        <td>
                            {{data.comment ? data.comment : ''}}
                        </td>
                        <td>
                            {{data.updatedDate | date : 'short'}}
                        </td>
                    </tr>
                </ng-container>
                <ng-template #load_else_comments>
                    <tr>
                        <td colspan="4" class="no-record" translate>lblNoRecordsFound</td>
                    </tr>
                </ng-template>
            </tbody>
        </table>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-lg" (click)="modal.close('Cancel click')"
            translate>lblCancel</button>
    </div>
</ng-template>